var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.793,
    height: 15.793,
    viewBox: "0 0 15.793 15.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2613",
    "data-name": "Group 2613",
    transform: "translate(-2.104 -2.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M13.456,4.031a6.893,6.893,0,1,0,2.525,2.534",
    fill: "none",
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M11.993,7.931a20.545,20.545,0,0,1-1.707,3.657A1.379,1.379,0,0,1,8.335,9.638,20.54,20.54,0,0,1,11.993,7.931Z",
    fill: "#565656",
    stroke: "#565656",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.150c0cf9.svg";
export { ForwardRef as ReactComponent };